import React from "react";
import { Form } from "react-bootstrap";

import { Einwilligungstext } from "./Einwilligungstext";
import { InputError } from "./InputError";
import { console } from "../../utils/functions";

export const Checkboxen = props => {
  let { checked, textNummer, onChange, errors } = props || {};
  if (!Array.isArray(checked)) checked = [];
  if (!Array.isArray(errors)) errors = [];
  textNummer = Number(textNummer);
  const id = "checkbox" + textNummer;
  textNummer--;
  const error = errors[textNummer];
  if (typeof onChange !== "function") onChange = () => {};

  const handleChange = React.useCallback((e) => {
    console.log(e);
    if (!e || !e.target) return;
    return onChange({
      index: textNummer,
      value: e.target.checked,
    });
  }, [onChange, textNummer]);

  return (
    <Form.Check id={id} className="mb-one">
      <Form.Check.Input
        type="checkbox"
        checked={!!checked[textNummer]}
        onChange={handleChange}
      />
      <Form.Check.Label className={"f-small" + (error ? " is-invalid" : "")}>
        <div className="text-black fw-bold form-check-label ps-one-half">
          <Einwilligungstext {...props} error={errors[textNummer]}></Einwilligungstext>
        </div>
      </Form.Check.Label>
      {textNummer !== 2
        ? <InputError className="ps-one-half">Bitte das Feld ausfüllen</InputError>
        : null
      }
    </Form.Check>
  );
};
